<template>
  <div>
    <Nav />

    <div class="resource-list container">
      <div class="columns">
        <div class="column is-one-quarter">
          <article class="message" v-if="categories.length > 0">
            <div class="message-header">
              <p>Category</p>
              <a
                class="reset"
                v-if="this.selectedCategory != null"
                v-on:click="resetCategoryFilter()"
              >
                <span class="icon is-small">
                  <i class="fas fa-undo"></i>
                </span>
              </a>
            </div>
            <div class="message-body">
              <div class="field">
                <div
                  class="control"
                  v-for="category in categories"
                  :key="'category-' + category.id"
                >
                  <label class="radio">
                    <input
                      type="radio"
                      :value="category.id"
                      v-model="selectedCategory"
                      v-on:change="refreshFilter()"
                    />
                    {{ category.name }}
                    <span class="tag is-warning">{{ category.count }}</span>
                  </label>
                </div>
              </div>
            </div>
          </article>

          <article class="message" v-if="audiences.length > 0">
            <div class="message-header">
              <p>Audience</p>
              <a
                class="reset"
                v-if="this.selectedAudience != null"
                v-on:click="resetAudienceFilter()"
              >
                <span class="icon is-small">
                  <i class="fas fa-undo"></i>
                </span>
              </a>
            </div>
            <div class="message-body">
              <div class="field">
                <div
                  class="control"
                  v-for="audience in audiences"
                  :key="'audience-' + audience.id"
                >
                  <label class="radio">
                    <input
                      type="radio"
                      :value="audience.id || -1"
                      v-model="selectedAudience"
                      v-on:change="refreshFilter()"
                    />
                    {{ audience.name || "N/A" }}
                    <span class="tag is-danger">{{ audience.count }}</span>
                  </label>
                </div>
              </div>
            </div>
          </article>

          <article class="message" v-if="tags.length > 0">
            <div class="message-header">
              <p>Tags</p>
              <a
                class="reset"
                v-if="this.selectedTag != null"
                v-on:click="resetTagFilter()"
              >
                <span class="icon is-small">
                  <i class="fas fa-undo"></i>
                </span>
              </a>
            </div>
            <div class="message-body">
              <div class="field">
                <div class="control" v-for="tag in tags" :key="'tag-' + tag.id">
                  <label class="radio">
                    <input
                      type="radio"
                      :value="tag.id || -1"
                      v-model="selectedTag"
                      v-on:change="refreshFilter()"
                    />
                    {{ tag.name || "N/A" }}
                    <span class="tag is-success">{{ tag.count }}</span>
                  </label>
                </div>
              </div>
            </div>
          </article>
        </div>

        <div class="column">
          <router-link
            :to="{
              name: 'resource',
              params: { id: resource.id, listProps, fromList: true }
            }"
            v-for="resource in resources"
            :key="resource.id"
          >
            <div class="box resource">
                <h3 class="title">{{ resource.title }}</h3>
              <div class="columns">
                <div class="column">
                  <img
                    :src="
                      'https://img.youtube.com/vi/' +
                        resource.videoId.split('?')[0] +
                        '/0.jpg'
                    "
                  />
                </div>
                <div class="column">
                  <p>{{ resource.annotation }}</p>
                  <p>
                    <b>Category:</b> {{ resource.category }}<br />
                    <b>Captions:</b> {{ resource.captions ? "Yes" : "No" }}
                  </p>
                  <hr />
                  <div class="tags">
                    <span
                      class="tag is-medium is-danger"
                      v-for="(audience, index) in resource.audiences.split(',')"
                      :key="index"
                      >{{ audience || "N/A" }}</span
                    >

                    <hr />
                    <span
                      class="tag is-medium is-success"
                      v-for="(tag, index) in resource.tags.split(',')"
                      :key="index"
                      >{{ tag || "N/A" }}</span
                    >
                  </div>
                </div>
              </div>
            </div>
          </router-link>

          <nav
            class="pagination is-centered"
            role="navigation"
            aria-label="pagination"
            v-if="pageCount > 1"
          >
            <a
              class="pagination-previous"
              v-if="page > 1"
              v-on:click="updatePage(page - 1)"
              >Previous</a
            >
            <a
              class="pagination-next"
              v-if="page < pageCount"
              v-on:click="updatePage(page + 1)"
              >Next page</a
            >
            <ul class="pagination-list">
              <li>
                <a
                  class="pagination-link"
                  aria-label="Goto page 1"
                  v-if="page > 2"
                  v-on:click="updatePage(1)"
                  >1</a
                >
              </li>
              <li>
                <span class="pagination-ellipsis" v-if="page > 2"
                  >&hellip;</span
                >
              </li>
              <li>
                <a
                  class="pagination-link"
                  v-if="page > pageCount - 1"
                  v-on:click="updatePage(pageCount - 2)"
                  >{{ page - 2 }}</a
                >
              </li>
              <li>
                <a
                  class="pagination-link"
                  v-if="page > 1"
                  v-on:click="updatePage(page - 1)"
                  >{{ page - 1 }}</a
                >
              </li>
              <li>
                <a class="pagination-link is-current" aria-current="page">{{
                  page
                }}</a>
              </li>
              <li>
                <a
                  class="pagination-link"
                  v-on:click="updatePage(page + 1)"
                  v-if="page < pageCount"
                  >{{ page + 1 }}</a
                >
              </li>
              <li>
                <a
                  class="pagination-link"
                  v-if="page < 2"
                  v-on:click="updatePage(page + 2)"
                  >{{ page + 2 }}</a
                >
              </li>
              <li>
                <span class="pagination-ellipsis" v-if="page < pageCount - 1"
                  >&hellip;</span
                >
              </li>
              <li>
                <a
                  class="pagination-link"
                  v-if="page < pageCount - 1"
                  v-on:click="updatePage(pageCount)"
                  >{{ pageCount }}</a
                >
              </li>
            </ul>
          </nav>
        </div>
      </div>
    </div>
    <Footer />
  </div>
</template>

<script>
import axios from "axios";
import Nav from "../components/Nav";
import Footer from "../components/Footer";

export default {
  name: "resourceList",
  props: ["parameters"],
  data() {
    if (this.parameters) {
      return { ...this.parameters };
    } else {
      return {
        resources: [],
        categories: [],
        selectedCategory: null,
        selectedAudience: null,
        selectedTag: null,
        tags: [],
        audiences: [],
        count: 0,
        page: 1,
        limit: 10
      };
    }
  },
  computed: {
    pageCount: function() {
      return Math.ceil(this.count / this.limit);
    },
    offset: function() {
      return (this.page - 1) * this.limit;
    },
    listProps: function() {
      return {
        resources: this.resources,
        audiences: this.audiences,
        selectedCategory: this.selectedCategory,
        selectedTag: this.selectedTag,
        selectedAudience: this.selectedAudience,
        tags: this.tags,
        count: this.count,
        page: this.page,
        limit: this.limit
      };
    }
  },

  mounted() {
    if (!this.parameters) {
      this.fetchData();
    }
  },

  methods: {
    fetchData: function() {
      console.log(`${process.env.VUE_APP_API_URL}resources`);

      const body = {
        limit: this.limit,
        offset: this.offset,
        category: this.selectedCategory,
        tag: this.selectedTag,
        audience: this.selectedAudience
      };
      axios
        .post(`${process.env.VUE_APP_API_URL}resources`, body)
        .then(response => {
          this.resources = response.data.resources;
          this.count = response.data.count;
          this.categories = response.data.categories;
          this.tags = response.data.tags;
          this.audiences = response.data.audiences;
        });
    },
    updatePage: function(newPage) {
      if (newPage >= 1 && newPage <= this.pageCount) {
        this.page = newPage;
        this.fetchData();
        window.scrollTo(0, 0);
      }
    },
    refreshFilter: function() {
      this.page = 1;
      this.fetchData();
    },
    resetCategoryFilter() {
      this.selectedCategory = null;
      this.fetchData();
    },
    resetAudienceFilter() {
      this.selectedAudience = null;
      this.fetchData();
    },
    resetTagFilter() {
      this.selectedTag = null;
      this.fetchData();
    },
    refreshresources() {
      this.fetchData();
    }
  },
  components: {
    Nav,
    Footer
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.resource-list {
  margin-top: 3rem;
}
.resource {
  margin-bottom: 2rem;
}
.fa-calendar:before {
  font-family: BlinkMacSystemFont, -apple-system, "Segoe UI", "Roboto", "Oxygen",
    "Ubuntu", "Cantarell", "Fira Sans", "Droid Sans", "Helvetica Neue",
    "Helvetica", "Arial", sans-serif;
}

.reset {
  text-decoration: none !important;
}
</style>
